import { FC } from 'react';

import { ResponsiveIframe, ResponsiveIframeContainer } from './BlockContent.styles';

type Props = { src: string; title?: string };

export const VideoIframe: FC<Props> = ({ src, title }) => (
    <ResponsiveIframeContainer>
        <ResponsiveIframe
            src={src}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen={true}
        />
    </ResponsiveIframeContainer>
);
